/* ai-badge.js v1.2.0 — dezenter "KI unterstützt"-Hinweis für Bilder (AI Act / Transparenzpflicht)
 *
 * Einbinden:  <script src="ai-badge.js" defer></script>
 * Verwenden:  <img src="…" data-ai-badge>
 *
 * Optionale Attribute am Bild:
 *   data-ai-badge="bottom-right | bottom-left | top-right | top-left"
 *   data-ai-badge="off"                 (schaltet den Badge aus — praktisch für CMS-Bindings)
 *   data-ai-badge-label="KI unterstützt"
 *   data-ai-badge-theme="light | dark"
 *   data-ai-badge-offset="12"           (px Abstand zur Kante)
 *   data-ai-badge-expand="hover | click | always"
 *   data-ai-badge-duration="420"        (ms)
 *   data-ai-badge-z="5"                 (z-index)
 *   data-ai-badge-mount="auto | parent" (auto = eigener Wrapper um das Bild,
 *                                        parent = vorhandenen Container nutzen)
 *
 * Globale Defaults per Script-Tag:
 *   <script src="ai-badge.js" data-label="KI-generiert" data-theme="dark" defer></script>
 *   erlaubt: data-label, data-position, data-theme, data-offset, data-expand,
 *            data-duration, data-z, data-mount
 *
 * Globale Defaults per JS:
 *   AIBadge.configure({ label, position, theme, offset, expand, duration, z, mount })
 * Nachladen/DOM-Änderungen: AIBadge.refresh()
 */
(function () {
  if (window.AIBadge) return;

  var uid = 0;
  var thisScript = document.currentScript;

  function coarse() { return !!(window.matchMedia && matchMedia('(pointer:coarse)').matches); }
  function num(v, fallback) { var n = parseFloat(v); return isFinite(n) ? n : fallback; }

  var defaults = {
    label: 'KI unterstützt',
    position: 'bottom-right',
    theme: 'light',
    offset: 12,
    expand: 'hover',
    duration: 420,
    z: 5,
    mount: 'auto'
  };

  // Defaults vom Script-Tag übernehmen (data-label, data-theme, …)
  if (thisScript) {
    var keys = ['label', 'position', 'theme', 'offset', 'expand', 'duration', 'z', 'mount'];
    for (var ki = 0; ki < keys.length; ki++) {
      var v = thisScript.getAttribute('data-' + keys[ki]);
      if (v != null && v !== '') defaults[keys[ki]] = v;
    }
  }

  var OFF = { off: 1, none: 1, 'false': 1, '0': 1 };

  var CSS = [
    '.aib-wrap{position:relative;display:inline-block;line-height:0;max-width:100%}',
    '.aib-host{position:relative}',
    // Die Pille selbst morpht: width animiert vom Kreis (26px) auf die gemessene Textbreite.
    // border-radius:999px bleibt konstant, dadurch wird aus dem Kreis stufenlos eine Kapsel.
    '.aib{--aib-dur:420ms;--aib-ease:cubic-bezier(.32,.72,0,1);--aib-spring:cubic-bezier(.32,.72,0,1);',
    'appearance:none;-webkit-appearance:none;margin:0;font:inherit;text-align:left;',
    'position:absolute;z-index:var(--aib-z,5);display:inline-flex;align-items:center;box-sizing:border-box;',
    'width:26px;height:26px;padding:2px;border-radius:999px;cursor:pointer;line-height:1;overflow:hidden;',
    'touch-action:manipulation;-webkit-tap-highlight-color:transparent;',
    'font-family:ui-sans-serif,system-ui,-apple-system,"Segoe UI",Helvetica,sans-serif;',
    '-webkit-backdrop-filter:blur(10px) saturate(150%);backdrop-filter:blur(10px) saturate(150%);',
    'transition:width var(--aib-dur) var(--aib-spring),',
    'box-shadow var(--aib-dur) var(--aib-ease),background-color var(--aib-dur) var(--aib-ease),',
    'transform var(--aib-dur) var(--aib-ease);outline:none}',
    // Feder mit minimalem Überschwingen — nur dort, wo linear() unterstützt wird
    '@supports (transition-timing-function:linear(0,1)){.aib{--aib-spring:linear(0,.0055 1.9%,.0217 3.9%,',
    '.0873 8%,.2137 12.6%,.5651 22.4%,.7074 26.9%,.8264 31.6%,.9128 36.4%,.9679 41.4%,.9974 46.7%,',
    '1.0106 52.6%,1.0129 60.4%,1.0053 72.6%,1)}}',
    '.aib[data-expand="always"]{cursor:default}',
    '.aib[data-theme="light"]{background:rgba(255,255,255,.78);border:1px solid rgba(9,9,11,.09);',
    'box-shadow:0 1px 2px rgba(9,9,11,.06),0 6px 16px -8px rgba(9,9,11,.22)}',
    '.aib[data-theme="dark"]{background:rgba(9,9,11,.58);border:1px solid rgba(255,255,255,.16);',
    'box-shadow:0 1px 2px rgba(0,0,0,.28),0 6px 16px -8px rgba(0,0,0,.5)}',
    '.aib:hover,.aib:focus-visible{transform:translateY(-1px)}',
    '.aib[data-theme="light"]:hover,.aib[data-theme="light"]:focus-visible{background:rgba(255,255,255,.94);',
    'box-shadow:0 1px 2px rgba(9,9,11,.06),0 10px 24px -10px rgba(9,9,11,.3)}',
    '.aib[data-theme="dark"]:hover,.aib[data-theme="dark"]:focus-visible{background:rgba(9,9,11,.74)}',
    '.aib:focus-visible{box-shadow:0 0 0 2px rgba(255,255,255,.9),0 0 0 4px rgba(9,9,11,.35)}',
    /* Das Icon bleibt als Anker stehen, nur sein Hintergrundkreis löst sich auf.
       Größe muss exakt in die content-box passen, sonst clippt overflow:hidden und
       der innere Kreis sitzt außermittig: 26 - 2*1px Border - 2*2px Padding = 20. */
    '.aib-i{flex:none;width:20px;height:20px;border-radius:999px;display:flex;align-items:center;justify-content:center;',
    'user-select:none;transition:background-color calc(var(--aib-dur)*.45) var(--aib-ease)}',
    '.aib-i svg{display:block;width:13px;height:13px;flex:none;',
    'transition:transform var(--aib-dur) var(--aib-spring)}',
    '.aib[data-theme="light"] .aib-i{background:rgba(9,9,11,.05);color:#3f3f46}',
    '.aib[data-theme="dark"] .aib-i{background:rgba(255,255,255,.1);color:#e4e4e7}',
    '.aib[data-open="1"] .aib-i{background:none}',
    '.aib[data-open="1"] .aib-i svg{transform:scale(.9)}',
    // Label wird von der Pille geclippt und schiebt sich verzögert hinter dem Icon hervor.
    // Zu (kein delay) blendet schneller aus als die Breite kollabiert — kein Stauchen des Texts.
    '.aib-label{flex:none;display:block;opacity:0;transform:translate3d(-6px,0,0);',
    'transition:opacity calc(var(--aib-dur)*.3) var(--aib-ease),',
    'transform calc(var(--aib-dur)*.5) var(--aib-spring)}',
    '.aib[data-open="1"] .aib-label{opacity:1;transform:none;',
    'transition-delay:calc(var(--aib-dur)*.16),calc(var(--aib-dur)*.12)}',
    // rechts 7px + 2px Padding + 1px Border = 10px optischer Abstand zur Kapselkante
    '.aib-label>span{display:block;white-space:nowrap;padding:0 7px 0 5px;font-size:11.5px;font-weight:500;',
    'letter-spacing:.005em}',
    '.aib[data-theme="light"] .aib-label>span{color:#3f3f46}',
    '.aib[data-theme="dark"] .aib-label>span{color:#e4e4e7}',
    // Touch: unsichtbare Vergrößerung der Trefferfläche auf 44px
    '@media (pointer:coarse){.aib::before{content:"";position:absolute;top:50%;left:50%;',
    'transform:translate(-50%,-50%);width:calc(100% + 18px);height:44px;border-radius:999px}}',
    '@media (prefers-reduced-motion:reduce){.aib,.aib-label,.aib-i,.aib-i svg{transition-duration:0s;',
    'transition-delay:0s}}'
  ].join('');

  function injectCSS() {
    if (document.getElementById('aib-style')) return;
    var s = document.createElement('style');
    s.id = 'aib-style';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function place(el, position, offset) {
    var o = offset + 'px';
    el.style.top = el.style.right = el.style.bottom = el.style.left = 'auto';
    if (position.indexOf('top') === 0) el.style.top = o; else el.style.bottom = o;
    if (position.indexOf('left') > -1) el.style.left = o; else el.style.right = o;
  }

  function infoSvg() {
    var NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.75');
    svg.setAttribute('stroke-linecap', 'round');
    var c = document.createElementNS(NS, 'circle');
    c.setAttribute('cx', '12'); c.setAttribute('cy', '12'); c.setAttribute('r', '9.25');
    var stem = document.createElementNS(NS, 'line');
    stem.setAttribute('x1', '12'); stem.setAttribute('y1', '11.25');
    stem.setAttribute('x2', '12'); stem.setAttribute('y2', '16.5');
    var dot = document.createElementNS(NS, 'line');
    dot.setAttribute('x1', '12'); dot.setAttribute('y1', '7.6');
    dot.setAttribute('x2', '12'); dot.setAttribute('y2', '7.7');
    svg.appendChild(c); svg.appendChild(stem); svg.appendChild(dot);
    return svg;
  }

  function readCfg(target) {
    var pos = (target.getAttribute('data-ai-badge') || '').trim();
    if (!pos || pos === 'true') pos = defaults.position;
    return {
      position: pos,
      label: target.getAttribute('data-ai-badge-label') || defaults.label,
      theme: target.getAttribute('data-ai-badge-theme') || defaults.theme,
      offset: num(target.getAttribute('data-ai-badge-offset'), num(defaults.offset, 12)),
      expand: target.getAttribute('data-ai-badge-expand') || defaults.expand,
      duration: num(target.getAttribute('data-ai-badge-duration'), num(defaults.duration, 420)),
      z: num(target.getAttribute('data-ai-badge-z'), num(defaults.z, 5)),
      mount: target.getAttribute('data-ai-badge-mount') || defaults.mount
    };
  }

  var CIRCLE = 26; // Durchmesser im geschlossenen Zustand, entspricht .aib width/height

  // Zielbreite der Pille = Kreis + Labelbreite. Das Label ist flex:none, seine
  // offsetWidth ist also die volle Textbreite, auch wenn die Pille sie gerade clippt.
  function measure(badge) {
    if (!badge.isConnected) return badge.__w || 0;
    var l = badge.__label;
    var w = Math.max(l.offsetWidth, l.scrollWidth, badge.__inner.scrollWidth);
    if (w > 0) { badge.__w = CIRCLE + Math.ceil(w); if (badge.__open) setOpen(badge, true); }
    return badge.__w || 0;
  }

  // Webfonts laden asynchron — sonst wird das Label beim Aufklappen abgeschnitten
  function remeasure(badge) {
    measure(badge);
    if (window.requestAnimationFrame) requestAnimationFrame(function () { measure(badge); });
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(function () { measure(badge); });
    }
  }

  /* Öffnen/Schließen wird explizit aus JS gesteuert (kein Verlass auf :hover-Selektoren).
     Animiert wird nur noch die Breite der Pille — Icon und Label hängen per
     [data-open] an CSS-Transitions, dadurch bleibt es eine einzige Bewegung. */
  function setOpen(badge, open) {
    badge.__open = !!open;
    badge.setAttribute('data-open', open ? '1' : '0');
    badge.setAttribute('aria-expanded', open ? 'true' : 'false');
    badge.style.width = open ? (badge.__w || measure(badge)) + 'px' : '';
  }

  function paint(badge, cfg, target) {
    badge.setAttribute('data-theme', cfg.theme);
    badge.setAttribute('data-expand', cfg.expand);
    badge.setAttribute('aria-label', cfg.label);
    if (!coarse()) badge.title = cfg.label; else badge.removeAttribute('title');
    badge.style.setProperty('--aib-dur', cfg.duration + 'ms');
    badge.style.setProperty('--aib-z', String(cfg.z));
    if (badge.__inner.textContent !== cfg.label) {
      badge.__inner.textContent = cfg.label;
      badge.__w = 0;
    }
    place(badge, cfg.position, cfg.offset);
    // React & Co. setzen Attribute beim Re-Render zurück: Verknüpfung erneuern
    if (target) {
      var d = target.getAttribute('aria-describedby');
      if (!d || d.indexOf(badge.id) === -1) {
        target.setAttribute('aria-describedby', (d ? d + ' ' : '') + badge.id);
      }
    }
    measure(badge);
    // Nutzerzustand bleibt erhalten; "always" ist immer offen
    setOpen(badge, cfg.expand === 'always' ? true : badge.__open);
  }

  function build(target, cfg) {
    var badge = document.createElement('button');
    badge.type = 'button';
    badge.className = 'aib';
    badge.id = 'aib-' + (++uid);

    var i = document.createElement('span');
    i.className = 'aib-i';
    i.setAttribute('aria-hidden', 'true');
    i.appendChild(infoSvg());

    var label = document.createElement('span');
    label.className = 'aib-label';
    label.setAttribute('aria-hidden', 'true'); // Text steckt bereits im aria-label des Buttons
    var inner = document.createElement('span');
    label.appendChild(inner);

    badge.appendChild(i);
    badge.appendChild(label);
    badge.__icon = i; badge.__label = label; badge.__inner = inner;
    badge.__open = false; badge.__pinned = false; badge.__w = 0;

    var mode = function () { return badge.getAttribute('data-expand'); };
    var fine = function (e) { return !e.pointerType || e.pointerType === 'mouse' || e.pointerType === 'pen'; };

    badge.addEventListener('pointerenter', function (e) {
      if (mode() === 'hover' && fine(e)) setOpen(badge, true);
    });
    badge.addEventListener('pointerleave', function (e) {
      if (mode() === 'hover' && fine(e) && !badge.__pinned) setOpen(badge, false);
    });
    // Touch: Tap öffnet, ein zweiter Tap schließt — Doppelauslösung unterdrücken
    badge.addEventListener('pointerdown', function (e) {
      if (fine(e)) return;
      e.stopPropagation();
      badge.__touch = true;
      if (mode() === 'always') return;
      badge.__pinned = !badge.__pinned;
      setOpen(badge, badge.__pinned);
    });
    badge.addEventListener('focus', function () {
      if (mode() !== 'always') setOpen(badge, true);
    });
    badge.addEventListener('blur', function () {
      if (mode() !== 'always' && !badge.__pinned) setOpen(badge, false);
    });
    badge.addEventListener('click', function (e) {
      // preventDefault ist Pflicht: liegt das Bild in einem <a>, würde der Klick sonst navigieren
      e.preventDefault();
      e.stopPropagation();
      if (badge.__touch) { badge.__touch = false; return; } // schon per pointerdown erledigt
      if (mode() === 'always') return;
      badge.__pinned = !badge.__pinned;
      setOpen(badge, badge.__pinned);
    });
    // kein natives Tooltip auf Touch (bliebe sonst als graue Blase stehen)
    return badge;
  }

  function isMedia(el) {
    var t = el.tagName.toLowerCase();
    return t === 'img' || t === 'video' || t === 'canvas' || t === 'svg' || t === 'picture';
  }

  function makeHost(el) {
    el.classList.add('aib-host');
    if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
    return el;
  }

  /* Mount-Punkt: Medien bekommen standardmäßig einen eigenen Wrapper, damit der Badge
     am Bild klebt und nicht in der Ecke irgendeines relativ positionierten Containers.
     data-ai-badge-mount="parent" nutzt stattdessen den vorhandenen Container (nichts
     wird umgehängt — für React/Vue-Bäume oder mehrere Bilder pro Container). */
  function mountPoint(target, cfg) {
    if (!isMedia(target)) return makeHost(target);

    var node = target;
    var p = node.parentNode;

    // <img> in <picture>: das <picture> umschließen, sonst bricht die Source-Auswahl
    if (p && p.nodeType === 1 && p.tagName === 'PICTURE') {
      node = p;
      p = node.parentNode;
    }
    if (!p || p.nodeType !== 1) return null; // kein Elternknoten -> nicht wrapbar

    if (p.classList.contains('aib-wrap')) return p;
    if (cfg.mount === 'parent') return makeHost(p);

    var wrap = document.createElement('span');
    wrap.className = 'aib-wrap';

    // Layout des Mediums spiegeln, damit Block-/Flex-/Grid-Kontexte nicht kippen
    var cs = getComputedStyle(node);
    if (/^(block|flex|grid|table)$/.test(cs.display)) wrap.style.display = 'block';

    var pcs = getComputedStyle(p);
    if (/flex|grid/.test(pcs.display)) {
      wrap.style.display = 'block';
      wrap.style.flex = cs.flex;
      wrap.style.alignSelf = cs.alignSelf;
      wrap.style.justifySelf = cs.justifySelf;
      wrap.style.gridArea = cs.gridArea;
    }

    p.insertBefore(wrap, node);
    wrap.appendChild(node);
    return wrap;
  }

  function undecorate(target) {
    var badge = target.__aib;
    if (badge && badge.parentNode) badge.parentNode.removeChild(badge);
    target.__aib = null;
    var d = target.getAttribute('aria-describedby');
    if (d && badge) {
      d = d.split(/\s+/).filter(function (x) { return x && x !== badge.id; }).join(' ');
      if (d) target.setAttribute('aria-describedby', d); else target.removeAttribute('aria-describedby');
    }
  }

  function decorate(target) {
    // "off" schaltet den Badge ab — so lässt sich das Attribut aus einem CMS-Feld befüllen
    var raw = (target.getAttribute('data-ai-badge') || '').trim().toLowerCase();
    if (OFF[raw]) { if (target.__aib) undecorate(target); return; }

    var cfg = readCfg(target);
    if (target.__aib && target.__aib.isConnected) { paint(target.__aib, cfg, target); return; }
    injectCSS();
    var host = mountPoint(target, cfg);
    if (!host) return;
    var badge = build(target, cfg);
    target.__aib = badge;
    host.appendChild(badge);
    paint(badge, cfg, target);
    remeasure(badge);
  }

  var busy = false, dirty = false, pending = 0;

  function schedule() {
    if (pending) return;
    pending = setTimeout(function () { pending = 0; refresh(); }, 120);
  }

  function refresh(root) {
    if (busy) { dirty = true; return; } // während eines Laufs nichts verlieren
    busy = true;
    try {
      var list = (root || document).querySelectorAll('[data-ai-badge]');
      for (var n = 0; n < list.length; n++) decorate(list[n]);
    } finally {
      busy = false;
      if (dirty) { dirty = false; schedule(); }
    }
  }

  window.AIBadge = {
    configure: function (opts) {
      for (var k in (opts || {})) if (opts[k] != null && opts[k] !== '') defaults[k] = opts[k];
      return this;
    },
    // idempotent: legt fehlende Badges an und aktualisiert bestehende in place
    refresh: refresh
  };

  document.addEventListener('pointerdown', function (e) {
    var open = document.querySelectorAll('.aib[data-open="1"]');
    for (var i = 0; i < open.length; i++) {
      var b = open[i];
      if (b.getAttribute('data-expand') === 'always' || b.contains(e.target)) continue;
      b.__pinned = false;
      setOpen(b, false);
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refresh(); });
  } else refresh();

  // eigene Knoten ignorieren, sonst läuft der Observer gegen sich selbst
  function ours(n) {
    return n.nodeType === 1 && n.closest && n.closest('.aib-wrap,.aib');
  }

  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1 && !ours(added[j])) { schedule(); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
